import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return {
    select: {
      margin: 0,
      color: function color(_ref) {
        var native = _ref.native,
          value = _ref.value;
        return native && value === '' ? theme.palette.grey.main : null;
      },
      borderRadius: function borderRadius(_ref2) {
        var edges = _ref2.edges,
          size = _ref2.size;
        switch (edges) {
          case 'rounded':
            return 99;
          case 'sharp':
            return 0;
          default:
            return size === 'small' ? theme.shape.borderRadius / 2 : theme.shape.borderRadius;
        }
      },
      '& .MuiSelect-select:focus': {
        borderRadius: 'inherit'
      },
      '& .MuiFormControl-root': {
        color: function color(_ref3) {
          var _color = _ref3.color;
          if (_color === 'inherit') {
            return 'inherit';
          }
          return null;
        }
      },
      '& .MuiSelect-selectMenu, & .MuiSelect-selectMenu:focus': {
        backgroundColor: function backgroundColor(_ref4) {
          var variant = _ref4.variant;
          if (variant === 'standard') {
            return 'transparent';
          }
          return null;
        }
      },
      '&.MuiInputBase-root': {
        border: function border(_ref5) {
          var variant = _ref5.variant;
          if (variant === 'standard') {
            return "none";
          }
          return variant === 'filled' ? "2px solid transparent" : null;
        },
        color: function color(_ref6) {
          var _color2 = _ref6.color;
          if (_color2 === 'inherit') {
            return 'inherit';
          }
          return null;
        }
      },
      '&.MuiInputBase-root:before, &.MuiInputBase-root:after': {
        display: function display(_ref7) {
          var variant = _ref7.variant;
          if (variant === 'standard') {
            return "none";
          }
          return null;
        }
      },
      '&.MuiInputBase-root .MuiSelect-select ': {
        fontWeight: function fontWeight(_ref8) {
          var weight = _ref8.weight;
          return weight;
        },
        fontSize: function fontSize(_ref9) {
          var size = _ref9.size;
          if (size === 'xsmall') {
            return '12px';
          }
          return null;
        },
        lineHeight: function lineHeight(_ref10) {
          var size = _ref10.size;
          if (size === 'xsmall') {
            return '2';
          }
          return null;
        }
      },
      '& .MuiFilledInput-root': {
        backgroundColor: theme.palette.grey.transparent
      },
      '& .MuiChip-root': {
        height: function height(_ref11) {
          var size = _ref11.size;
          return size === 'small' ? 'auto' : null;
        },
        '& .MuiChip-deleteIcon': {
          marginRight: function marginRight(_ref12) {
            var size = _ref12.size;
            return size === 'small' ? 0 : null;
          }
        }
      },
      '& .MuiSelect-root': {
        padding: function padding(_ref13) {
          var size = _ref13.size;
          if (size === 'xsmall') {
            return '2px 4px !important';
          }
          return size === 'small' ? theme.spacing(1, 8, 1, 2) + " !important" : theme.spacing(2.8, 8, 2.8, 4) + " !important";
        },
        minHeight: 24
      },
      '&.MuiInputBase-root .MuiSelect-icon': {
        fontSize: function fontSize(_ref14) {
          var size = _ref14.size;
          if (size === 'xsmall') {
            return '20px';
          }
          return null;
        },
        right: function right(_ref15) {
          var size = _ref15.size;
          if (size === 'xsmall') {
            return '2px !important';
          }
          return null;
        },
        top: function top(_ref16) {
          var size = _ref16.size;
          if (size === 'xsmall') {
            return 'calc(50% - 9px) !important';
          }
          return null;
        },
        color: function color(_ref17) {
          var _color3 = _ref17.color;
          if (_color3 === 'inherit') {
            return 'inherit';
          }
          return null;
        }
      },
      '& .Mui-focused': {
        backgroundColor: function backgroundColor(_ref18) {
          var variant = _ref18.variant;
          if (variant === 'standard') {
            return 'transparent';
          }
          return null;
        },
        border: function border(_ref19) {
          var variant = _ref19.variant,
            required = _ref19.required;
          if (variant === 'standard') {
            return 'none';
          }
          if (variant === 'filled') {
            return "2px solid " + (required ? theme.palette.secondary.main : null);
          }
          return null;
        }
      },
      '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: function borderColor(_ref20) {
          var value = _ref20.value,
            required = _ref20.required;
          return required && !value ? theme.palette.secondary.main : null;
        }
      }
    },
    placeholder: {
      fontWeight: function fontWeight(_ref21) {
        var weight = _ref21.weight;
        return weight;
      },
      fontSize: function fontSize(_ref22) {
        var size = _ref22.size;
        if (size === 'xsmall') {
          return '12px';
        }
        return null;
      },
      lineHeight: function lineHeight(_ref23) {
        var size = _ref23.size;
        if (size === 'xsmall') {
          return '2';
        }
        return null;
      },
      color: function color(_ref24) {
        var _color4 = _ref24.color;
        if (_color4 === 'inherit') {
          return 'inherit';
        }
        return theme.palette.grey.main;
      }
    },
    nativePlaceholder: {
      '& .MuiInputBase-root:before': {
        color: theme.palette.grey.main,
        position: 'absolute',
        display: 'block',
        pointerEvents: 'none',
        content: function content(_ref25) {
          var placeholder = _ref25.placeholder;
          return "\"" + placeholder + "\"";
        },
        padding: function padding(_ref26) {
          var size = _ref26.size;
          return size === 'small' ? theme.spacing(1, 8, 1, 2) : theme.spacing(3, 8, 3, 4);
        }
      }
    }
  };
});
export default useStyles;